export default __webpack_public_path__ + "static/media/screen4.8c1a4b63.png";